<template>
        <Dialog :title="title" class="m-dialog" :custom-class="customClass" :visible.sync="isShow" :width="width" :fullscreen="fullscreen" :top="top" :modal="modal" :show-close="showClose" :center="center" :lock-scroll="lockScroll" :before-close="hide" :close-on-click-modal="closeOnClickModal">
            <div class="m-dialog-content" ref="content"></div>
        </Dialog>
</template>

<script>
    import { Dialog, Button } from 'element-ui'
    export default {
        props: {
            title: {
                type: String,
                default: '确定'
            },
            width: {
                type: String,
                default: '50%'
            },
            customClass: {
                type: String,
                default: ''
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            top: String,
            modal: {
                type: Boolean,
                default: true
            },
            showClose: true,
            center: {
                type: Boolean,
                default: false,
            },
            lockScroll: {
                type: Boolean,
                default: true
            },
            closeOnClickModal: {
                type: Boolean,
                default: false
            },
            beforeClose:{
                type: Function
            }
        },
        data(){
            return {
                isShow: false
            }
        },
        components: {
            Dialog, Button
        },
        mounted(){
            
        },
        methods: {
            onBeforeClose(){
                let vm = this;
                if(vm.beforeClose && typeof(vm.beforeClose) == 'function'){
                    if(vm.beforeClose()){
                        vm.hide();
                    }
                }else{
                    vm.hide();
                }
            },
            show(){
                this.isShow = true;
                let ele = document.activeElement;
                if(ele && ele.nodeName.toLowerCase() == 'button') ele.blur();
                document.body.appendChild(this.$el);
            },
            hide(){
                let vm = this;
                vm.isShow = false;
                // setTimeout(function(){
                //     document.body.removeChild(this.$el);
                // }.bind(vm), 300)
                setTimeout(function(){
                    document.body.removeChild(this.$el);
                }.bind(vm), 0)
            }
        }
    }
</script>

<style lang="scss" >
    // @import 'src/style/common';
    .m-dialog{
        .el-dialog{
            border-radius: 4px;
            background-color: #fff;
            &.pop-edit-list .el-dialog__body{
                background:url('../../../assets/images/xgqd01.png') 0px bottom no-repeat,
                url('../../../assets/images/xgqd02.png') right 20px no-repeat;
            }
            &.pop-import .el-dialog__body{
                background:url('../../../assets/images/drbg03.png') left 40px no-repeat,
                url('../../../assets/images/drbg04.png') right 70px no-repeat;
            }
            &.pop-add-list .el-dialog__body{
                background:url('../../../assets/images/jrsdqd01.png') left 120px no-repeat,
                url('../../../assets/images/jrsdqd02.png') right 155px no-repeat;
            }
            &.pop-edit-book .el-dialog__body{
                background:url('../../../assets/images/bjsm03.png') left bottom no-repeat,
                url('../../../assets/images/bjsm04.png') right bottom no-repeat;
            }
            &.pop-ys .el-dialog__body{
                background:url('../../../assets/images/ys01.png') left 60px no-repeat,
                url('../../../assets/images/ys02.png') right bottom no-repeat;
            }
            &.pop-ysjg .el-dialog__body{
                background:url('../../../assets/images/ys03.png') left bottom no-repeat,
                url('../../../assets/images/ys04.png') right 10px no-repeat;
            }
            &.pop-pgmy .el-dialog__body{
                background:url('../../../assets/images/111.png') right center no-repeat;
            }
            &.pop-cctj .el-dialog__body{
                background:url('../../../assets/images/777.png') right bottom no-repeat,
                    url('../../../assets/images/888.png') left center no-repeat;
            } 
            &.pop-cjjs .el-dialog__body{
                background:url('../../../assets/images/333.png') left bottom no-repeat;
            }
            &.pop-tmh .el-dialog__body{
                background:url('../../../assets/images/222.png') bottom repeat-x;
            }
            &.pop-fpgcd .el-dialog__body{
                background:url('../../../assets/images/444.png') right top no-repeat,
                url('../../../assets/images/555.png') left 100px no-repeat;
            }
            .el-dialog__body{
                padding-bottom: 24px;
                padding-top: 17px;
            }
            .el-dialog__header{
                background:#eff4f9;
                padding:9px 20px;
                // margin-bottom: 17px;
                border-radius: 4px 4px 0 0;
                .el-dialog__title{
                    font-size:14px;
                    color:#3b455f;
                    font-weight:bold;
                }
                .el-dialog__headerbtn{
                    top:10px;
                }
                .el-dialog__close{
                    color: #333;
                }
            }
            
        }
        &-content{
            word-break: break-all;
        }
    }
</style>





// WEBPACK FOOTER //
// src/common/plugin/dialog/dialog.vue